<div class="sh-detail-layout">
    <aside *ngIf="asideContent" class="sh-detail-layout__aside">
        <div class="sh-page-section--wide sh-page-section--vertical--narrow sh-sticky-wrapper">
            <div class="sh-sticky-header" [ShDragData]="dragData">
                <ng-container *ngTemplateOutlet="asideContent"></ng-container>
            </div>
        </div>
    </aside>
    <section class="sh-detail-layout__content">
        <div class="sh-page-section--wide sh-page-section--vertical--narrow">
            <ng-container *ngTemplateOutlet="mainContent"></ng-container>
            <ng-content><!--fallback--></ng-content>
        </div>
    </section>
</div>
